;(function () {
	let $generalContainer = $('.Product');

	if(!$generalContainer.length){
		return null;
	}

	let $container = $('.Product__Info');
	let $sliderContainer = $('.Product__Slideshow');
	let $productOptions = $container.find('.ProductForm__Option');
	let $options = $productOptions.find('[type="radio"]');
	let productInfo = JSON.parse($container.find('[data-product-json]').html()).product;
	let optionLength = productInfo.options.length;
	let currentVariant = {};

	function setAvailableValues(variants, selected){
		$options.addClass('option-disabled');
		let originalSelectedKeys        = Object.keys(selected);
		let maxOptionKey        = `option${originalSelectedKeys.length + 1}`;

		let variantOptions = variants.map(variant => {
			let keys = Object.keys(variant).filter((key) => {
				return key.indexOf("option") === 0 || key === "available";
			});

			return Object.assign({}, {}, ...keys.map((key, index) => {
				if(key === "available"){
					return {
						[key]: variant[key]
					}
				}

				if(key > maxOptionKey){
					return {};
				}

				return {
					[key]: variant[key]
				}
			}));
		});

		Object.keys(variantOptions[0]).forEach(key => {
			if(key === "available"){
				return;
			}

			if(selected.hasOwnProperty(key)){
				return;
			}

			selected[key] = null;
		});

		let selectedKeys = Object.keys(selected);
		let combinations = selectedKeys.length > 0 ? selectedKeys.map(excludeKey => {
			return Object.assign({}, {}, ...selectedKeys.map(key => {
				if(excludeKey === key){
					return {};
				}

				return {
					[key]: selected[key]
				}
			}));
		}) : [{}];

		let availableValues = {};

		variantOptions.map(options => {
			return Object.assign({}, {}, ...combinations.map(combination => {
				const isSubset = Object.keys(combination).map(key => {
					if(combination[key] === null){
						return true;
					}

					return options.hasOwnProperty(key) && combination[key] === options[key];
				}).includes(false) !== true;

				if(!isSubset){
					return {};
				}

				if(!options.available){
					return {};
				}

				return Object.assign({}, {}, ...Object.keys(options).filter(key => {
					return key !== "available" && !combination.hasOwnProperty(key);
				}).map(optionName => {
					return {
						[optionName]: [options[optionName]]
					}
				}));
			}));
		}).filter(options => {
			return Object.keys(options).length > 0
		}).forEach(options => {
			Object.keys(options).forEach(key => {
				if(!availableValues.hasOwnProperty(key)){
					availableValues[key] = [];
				}

				availableValues[key] = availableValues[key].concat(options[key]).filter((value, index, self) => {
					return self.indexOf(value) === index;
				});
			})
		});

		let newAvailableValues = Object.assign({}, {}, ...Object.keys(availableValues).sort().map(key => {
			return {
				[key]: availableValues[key]
			}
		}));

		Object.keys(newAvailableValues).map((value, index, self) => {
			newAvailableValues[value].forEach(availableValue => {
				$productOptions.find(`input[type='radio'][data-option-position='${index + 1}'][value='${availableValue}']`).removeClass('option-disabled');
			})
		});
	}

	function findSelectedOptions(){
		let $options = $container.find('.ProductForm__Option [type="radio"]:checked');

		$options.each(function() {
			let $target = $(this);
			let optionPosition = $target.data('option-position');
			currentVariant[`option${optionPosition}`] = $target.attr('value');
		});
	}

	findSelectedOptions();
	setAvailableValues(productInfo.variants, currentVariant);

	$generalContainer.on('variant:changed', function (e) {
		let detail = e.detail;

		if(!detail.variant) {
			return null;
		}

		for (let i = 1; i <= optionLength; i++){
			currentVariant[`option${i}`] = detail.variant[`option${i}`];
		}

		setAvailableValues(productInfo.variants, currentVariant);
	});

	function scrollToImage($target){
		let selectedImageId = $target.data('image-id');

		if (!selectedImageId){
			return null;
		}

		$('html, body').animate({
			scrollTop: $sliderContainer.find(`[data-image-id="${selectedImageId}"]`).offset().top
		}, 800);
	}

	$(document).ready(function () {
		let $selectedColor = $('[data-color-changer]:checked');

		if(!$selectedColor.length){
			return null;
		}

		scrollToImage($selectedColor);
	});

	$generalContainer.on('change', '[data-color-changer]', (e) => {
		let $target = $(e.target);

		scrollToImage($target);
	})
})();

;(function() {
    let accordionContainer = $('.js-accordion-container')
    let accordionToggler = $('.js-accordion-toggler');

    if (accordionToggler.length < 1) {
        return;
    }

    /*
    * accordionContainer - use it, if you need add one event listener , instead not for all accordions togglers
    * accordionToggler - accordion title, icon on some thing else.
    * accordion - accordion item container
    * accordionContent - content which animated
    */

    if (accordionContainer.length) {
        accordionContainer.on('click', '.js-accordion-toggler', toggleAccordion);
    } else {
        accordionToggler.click(toggleAccordion);
    }

    function changeToggler(toggler) {
        if (toggler.text() === 'Read more') {
            toggler.text('Read less');
        } else {
            toggler.text('Read more');
        }
    }

    function toggleAccordion() {
        let accordion = $(this).parents('.js-accordion');
        let accordionContent = accordion.find('.js-accordion-content');

        changeToggler($(this));
        accordion.toggleClass('open');
        accordionContent.stop().slideToggle(400, function() {
            $(this).css('height', '');
        });
    }
}());
;(function () {
	let $cartContainer = $('#sidebar-cart');

	if(!$cartContainer.length){
		return null;
	}

	let $buttonsContainer = $cartContainer.find('.js-additional-buttons');

	if(!$buttonsContainer.length){
		return null;
	}

	$cartContainer.on('click', '.js-additional-buttons-open', (e) => {
		$buttonsContainer.addClass('active');
	});

	$cartContainer.on('click', '.js-additional-buttons-close', (e) => {
		$buttonsContainer.removeClass('active');
	});

	$('body').on('click', '.PageOverlay', (e) => {
		let $target = $(e.target);

		if($target.hasClass('is-visible')){
			return null;
		}

		let isCartHidden = !Boolean($cartContainer.attr('aria-hidden'));

		if (!isCartHidden){
			$buttonsContainer.removeClass('active');
		}
	});
})();


;(function() {

    const $sorter = $('#sort-by');
    let sortBy = false;

    if (!$sorter.length) {
        return;
    }

    if (window.location.search.length) {
        sortBy = new URLSearchParams(window.location.search).get('sort_by')
    }

    if(sortBy) {
        $sorter.val(sortBy)
    }

    $sorter.on('change', (e) => {
        const { value } = e.currentTarget;

        window.location = `?sort_by=${value}`
    })

}());

